import React from 'react'

import { NodeViewWrapper, ReactNodeViewProps } from '@tiptap/react'
import styled from 'styled-components/native'

import { getFontStyles } from '../../../../styles'

type TokenComponentProps = ReactNodeViewProps

// eslint-disable-next-line lyrahealth/no-react-native-text
const TextContainer = styled.Text<{ selected: boolean }>(({ theme, selected }) => ({
  ...getFontStyles(theme.colors).body.badge,
  backgroundColor: selected ? theme.colors.backgroundHighlightPrimary : theme.colors.backgroundSection,
  borderRadius: '4px',
  padding: `0 ${theme.spacing['4px']}`,
  userSelect: 'none',
}))

export const TokenComponent: React.FC<TokenComponentProps> = ({ node, ...props }) => {
  return (
    <NodeViewWrapper as='span' style={{ display: 'inline-block', cursor: 'grab', userSelect: 'none' }}>
      <TextContainer data-drag-handle dataSet={{ 'drag-handle': true }} selected={props.selected}>
        {node.attrs.label}
      </TextContainer>
    </NodeViewWrapper>
  )
}
